import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Meet the Fear",
    opening: localizedGenderNode(
      [
      "Today I don't push myself. I just notice: there is fear in me about meeting people.",
      "I am with myself.",
      "One breath."
    ],
      [
      "Today I don't push myself. I just notice: there is fear in me about meeting people.",
      "I am with myself.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What happens in me when I think about meeting people?",
      "Which part of me wants to disappear or run?",
      "What do I need to hear from myself right now?"
    ],
      [
      "What happens in me when I think about meeting people?",
      "Which part of me wants to disappear or run?",
      "What do I need to hear from myself right now?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "When I name it, it feels less frightening."
    ],
      [
      "When I name it, it feels less frightening."
    ]
    ),
    action: localizedGenderNode(
      "I tell myself quietly \"I am with me.\"",
      "I tell myself quietly \"I am with me.\""
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "The First Moment",
    opening: localizedGenderNode(
      [
      "Today I notice the first moment when the fear rises.",
      "I do not move ahead. I only notice.",
      "One breath."
    ],
      [
      "Today I notice the first moment when the fear rises.",
      "I do not move ahead. I only notice.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When during the day does the fear appear?",
      "What is the first thing I feel in my body?",
      "What is the first thought that jumps in?"
    ],
      [
      "When during the day does the fear appear?",
      "What is the first thing I feel in my body?",
      "What is the first thought that jumps in?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "The first moment is a small crack of choice."
    ],
      [
      "The first moment is a small crack of choice."
    ]
    ),
    action: localizedGenderNode(
      "when it rises, I pause for two breaths.",
      "when it rises, I pause for two breaths."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "My Body",
    opening: localizedGenderNode(
      [
      "Today I give my body one word.",
      "No judgment. Only description.",
      "One breath."
    ],
      [
      "Today I give my body one word.",
      "No judgment. Only description.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where does it sit in my body? (belly / chest / throat)",
      "What is my body trying to do for me?",
      "What small softening can I give it?"
    ],
      [
      "Where does it sit in my body? (belly / chest / throat)",
      "What is my body trying to do for me?",
      "What small softening can I give it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "My body is not against me. It is trying to protect."
    ],
      [
      "My body is not against me. It is trying to protect."
    ]
    ),
    action: localizedGenderNode(
      "hand on my chest for ten seconds.",
      "hand on my chest for ten seconds."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "The Story in My Head",
    opening: localizedGenderNode(
      [
      "Today I separate what happens from what I tell myself.",
      "I see the story.",
      "One breath."
    ],
      [
      "Today I separate what happens from what I tell myself.",
      "I see the story.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What story do I tell about a meeting?",
      "What meaning do I give to looks or silence?",
      "What softer possibility exists?"
    ],
      [
      "What story do I tell about a meeting?",
      "What meaning do I give to looks or silence?",
      "What softer possibility exists?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A story is not a fact."
    ],
      [
      "A story is not a fact."
    ]
    ),
    action: localizedGenderNode(
      "I tell myself \"this is a story, not certainty.\"",
      "I tell myself \"this is a story, not certainty.\""
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Triggers",
    opening: localizedGenderNode(
      [
      "Today I notice what triggers the fear.",
      "It is knowledge, not blame.",
      "One breath."
    ],
      [
      "Today I notice what triggers the fear.",
      "It is knowledge, not blame.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What kind of place, person, or noise activates me?",
      "What makes it stronger?",
      "What softens it even a little?"
    ],
      [
      "What kind of place, person, or noise activates me?",
      "What makes it stronger?",
      "What softens it even a little?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "When I know a trigger, I am less surprised."
    ],
      [
      "When I know a trigger, I am less surprised."
    ]
    ),
    action: localizedGenderNode(
      "I pick one trigger and look at it without running.",
      "I pick one trigger and look at it without running."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "My Pattern",
    opening: localizedGenderNode(
      [
      "Today I look at my pattern around people.",
      "No criticism.",
      "One breath."
    ],
      [
      "Today I look at my pattern around people.",
      "No criticism.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I do to protect myself in a meeting?",
      "What is the cost of that protection?",
      "What could be a little different?"
    ],
      [
      "What do I do to protect myself in a meeting?",
      "What is the cost of that protection?",
      "What could be a little different?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small change is enough to loosen a loop."
    ],
      [
      "A small change is enough to loosen a loop."
    ]
    ),
    action: localizedGenderNode(
      "I allow myself a small change once.",
      "I allow myself a small change once."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Fear of Rejection",
    opening: localizedGenderNode(
      [
      "Today I touch the fear underneath.",
      "I stay with it for a moment.",
      "One breath."
    ],
      [
      "Today I touch the fear underneath.",
      "I stay with it for a moment.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What am I most afraid will happen in a meeting?",
      "What inner sentence appears when I imagine rejection?",
      "What would help me feel a little safer?"
    ],
      [
      "What am I most afraid will happen in a meeting?",
      "What inner sentence appears when I imagine rejection?",
      "What would help me feel a little safer?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Fear of rejection is a need for closeness and safety."
    ],
      [
      "Fear of rejection is a need for closeness and safety."
    ]
    ),
    action: localizedGenderNode(
      "I notice the fear without fighting it.",
      "I notice the fear without fighting it."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "The Critical Voice",
    opening: localizedGenderNode(
      [
      "Today I notice the voice that criticizes me before a meeting.",
      "I listen without believing it.",
      "One breath."
    ],
      [
      "Today I notice the voice that criticizes me before a meeting.",
      "I listen without believing it.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What does the critical voice say to me?",
      "What word does it use about me?",
      "What gentle voice could answer it?"
    ],
      [
      "What does the critical voice say to me?",
      "What word does it use about me?",
      "What gentle voice could answer it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A critical voice is a frightened voice."
    ],
      [
      "A critical voice is a frightened voice."
    ]
    ),
    action: localizedGenderNode(
      "one gentle sentence to myself.",
      "one gentle sentence to myself."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Inner Boundary",
    opening: localizedGenderNode(
      [
      "Today I set an inner boundary in a meeting.",
      "To keep myself safe.",
      "One breath."
    ],
      [
      "Today I set an inner boundary in a meeting.",
      "To keep myself safe.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is not ok for me in social spaces?",
      "How does my body signal that it's too much?",
      "What inner boundary can I set without words?"
    ],
      [
      "What is not ok for me in social spaces?",
      "How does my body signal that it's too much?",
      "What inner boundary can I set without words?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "An inner boundary creates breathing room."
    ],
      [
      "An inner boundary creates breathing room."
    ]
    ),
    action: localizedGenderNode(
      "I remind myself of that boundary before I go.",
      "I remind myself of that boundary before I go."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "What I Need",
    opening: localizedGenderNode(
      [
      "Today I look for the need beneath the fear.",
      "Not a solution, only a need.",
      "One breath."
    ],
      [
      "Today I look for the need beneath the fear.",
      "Not a solution, only a need.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I need in a meeting to feel safer?",
      "What helps me feel seen without effort?",
      "What small thing can I give myself?"
    ],
      [
      "What do I need in a meeting to feel safer?",
      "What helps me feel seen without effort?",
      "What small thing can I give myself?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "When I see a need, something calms down."
    ],
      [
      "When I see a need, something calms down."
    ]
    ),
    action: localizedGenderNode(
      "I give myself one small thing before a meeting.",
      "I give myself one small thing before a meeting."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "A Small Request",
    opening: localizedGenderNode(
      [
      "Today I form a small request to myself.",
      "No pressure.",
      "One breath."
    ],
      [
      "Today I form a small request to myself.",
      "No pressure.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small request can I ask of myself today?",
      "How does it sound when I say it softly?",
      "What will help me remember it in the moment?"
    ],
      [
      "What small request can I ask of myself today?",
      "How does it sound when I say it softly?",
      "What will help me remember it in the moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A soft request is kinder than a command."
    ],
      [
      "A soft request is kinder than a command."
    ]
    ),
    action: localizedGenderNode(
      "I repeat the request once.",
      "I repeat the request once."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Presence Before a Meeting",
    opening: localizedGenderNode(
      [
      "Today I practice presence right before entering.",
      "That is enough for today.",
      "One breath."
    ],
      [
      "Today I practice presence right before entering.",
      "That is enough for today.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What helps me remember I am not alone inside?",
      "What small anchor can I bring with me?",
      "What do I want to remember inside the meeting?"
    ],
      [
      "What helps me remember I am not alone inside?",
      "What small anchor can I bring with me?",
      "What do I want to remember inside the meeting?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Presence is a soft shield."
    ],
      [
      "Presence is a soft shield."
    ]
    ),
    action: localizedGenderNode(
      "one anchor with me (a word / a breath / a touch).",
      "one anchor with me (a word / a breath / a touch)."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "A Small Step in the Space",
    opening: localizedGenderNode(
      [
      "Today I choose a small step inside a social space.",
      "Not a revolution.",
      "One breath."
    ],
      [
      "Today I choose a small step inside a social space.",
      "Not a revolution.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small step fits me?",
      "How will I know it was enough even if small?",
      "What do I ask of myself after it?"
    ],
      [
      "What small step fits me?",
      "How will I know it was enough even if small?",
      "What do I ask of myself after it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Small steps build trust."
    ],
      [
      "Small steps build trust."
    ]
    ),
    action: localizedGenderNode(
      "one small step, and that is enough.",
      "one small step, and that is enough."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Return Sentence",
    opening: localizedGenderNode(
      [
      "Today I finish with a return sentence for hard moments.",
      "I stay with myself.",
      "One breath."
    ],
      [
      "Today I finish with a return sentence for hard moments.",
      "I stay with myself.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about this fear?",
      "What helps me most when it rises?",
      "My short return sentence is:"
    ],
      [
      "What did I learn about this fear?",
      "What helps me most when it rises?",
      "My short return sentence is:"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I can stay present for a moment before I react."
    ],
      [
      "I can stay present for a moment before I react."
    ]
    ),
    action: localizedGenderNode(
      "I say my return sentence once.",
      "I say my return sentence once."
    ),
  },
].map(buildNormalizedDay);

export const fearMeetingPeopleSocialEventsBlueprintEn = buildNormalizedPilotBlueprint({
  id: "fear_meeting_people_social_events_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "fear_meeting_people_social_events",
  category: "anxiety",
  journeyName: {
    he: "פחד ממפגש עם אנשים / אירועים חברתיים",
    en: "Fear of meeting people / social events",
    es: "Miedo a encontrarme con gente / eventos sociales",
  },
  days,
});

export default fearMeetingPeopleSocialEventsBlueprintEn;
